import React, { Component } from "react";
import '../InitialForm/InitialFormStyleSheet.css';
import { isValidPhoneNumber, validateEmail ,validateName} from "../HWLibrary/HWUtils";
import { s360ConfigService } from "../Services/S360Config";
import uuid from "react-uuid";
import {scrollToPosition} from '../../utils/scrollerToIndex'



class TextBox extends Component {
  
    constructor(props) {
        super(props);
        this.messageRef = React.createRef();
         
      
       
    }
  
 
    componentDidUpdate(prevProps){
        
        console.log(this.props.error,"errorMessage","Please enter a valid " + this.props.item.label.toLowerCase())
    }

    returnPlaceHolder(text,required){
        return required ? text + '*' : text;
    }
 
    render() {
        
        console.log(this.props.item.required,this.props.item.label,'item cheeking')
        return (
            <div className="s360-initial-form-textbox-container" style={this.formInputBoxContainerStyle()} >
                {/* <fieldset style={{"border-bottom":"1px solid silver","margin":"6px -1px","padding":".35em .625em .75em"}}> */}
                <fieldset style={{"border-bottom":"1px solid silver","margin":"6px -1px"}}>
              {console.log("id",this.props.idxx)}
                    <legend   id={'lbl'+this.props.idxx} style={{"width":"auto","padding":"2px","marginBottom":"4px","fontSize":"10px","lineHeight":"inherit","color":"rgb(108 103 103)","border":"0","borderBottom":"none","display":"none","fontFamily":"poppins"}}>{this.props.item.label}{this.props.item.required? '*' :''}</legend>
                        <input   type="text" id={this.props.idxx} ref={this.messageRef} className="s360-initial-form-textbox-input" onInput = {()=>this.myFunction(this.props.idxx,'lbl'+this.props.idxx)}   style={this.formInputBoxStyle()} placeholder={this.returnPlaceHolder(this.props.item.label,this.props.item.required)} autoComplete="off" maxLength={(this.props.item.label==='Phone Number'||this.props.item.label==='Contact Number')? 10 :50} />

                    </fieldset>
                    {this.props.error  === "Please enter a valid " + this.props.item.label.toLowerCase() ? <small>{this.props.error}</small>:null}
            </div>
        );
    }

    myFunction(idx,lbl) {
         
        
        if(document.getElementById(idx).value.length)
        document.getElementById(lbl).style.display = "block";
        else
        document.getElementById(lbl).style.display = "none";

      }

    formInputBoxContainerStyle = () => {
        return {
            color: s360ConfigService.config.designDetails.headerColor,
        }
    }



    formInputBoxStyle = () => {
        return {
            borderColor: s360ConfigService.config.designDetails.headerColor,
            color: s360ConfigService.config.designDetails.headerColor,
            backgroundColor:s360ConfigService.config.designDetails.pageBackgroundColor 
        }
    }

    onClickInput = (e) => {
        if (e.target.value === this.props.item.label) {
            e.target.style.color='rgb(0,0,0)';
            this.messageRef.current.value = "";
            document.getElementById("label").style.display = "block";
        }
    }

    onInputOut = (e) => {
        if (!e.target.value || !e.target.value.trim) {
            e.target.style.color='inherit';
            this.messageRef.current.value = this.props.item.label;
        }
    };

    value = () => { 
        if ((!this.messageRef.current.value || !this.messageRef.current.value.trim()) || (this.messageRef.current.value.trim() === this.props.item.label)) {
            return {}
        }
        let aValue = {};
        aValue[this.props.item.label] = this.messageRef.current.value; 
        return aValue;
    };

    // isValidate =()=>{
    //     let validate ={status:false,message:""}
    //     //json filed will be compared with user input 
    //     //validation based on form fild recieved
    //            //isrequired and empty validate false
    //             //max ength > & <min length validate false
    //             //format based on validate field (if email -> email validation,phone -> phone vlidaion)
    //     //if validation is correct --> validate.status = true
    //     //else --> validate.status = false and validate.message ="email "
    //     return validate
    // }
    isValidate = (jsonField,input)=>{
        if(jsonField.primaryField || jsonField.required){
        //fild is requird
        console.log(input.value.length,'length')
          if(input.value.length === 0){
            
            //popup for filed is e=required
            this.props.actions.showPopUpMessage(`${jsonField.label} is required`);
            return false
          }
          else if(input.value.length<jsonField.minLength){

            this.props.actions.showPopUpMessage(`${jsonField.label} length is too short`);
            return false
          }
          else if( input.value.length >jsonField.maxLength){
          
            this.props.actions.showPopUpMessage(`${jsonField.label} length is too big`);
            return false
          }
          else if(jsonField.validate==='Phone'){

            if(!input.value.match("^[0-9]*$"))
              {
                this.props.actions.showPopUpMessage(`Enter Valid ${jsonField.label}`);
                return false;
              }
        
          }
          else if(jsonField.validate==='Email'){
            if(!input.value.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i))
              {
                this.props.actions.showPopUpMessage(`Enter Valid ${jsonField.label}`);
                return false;
              }
        
          }
          // else if(jsonField.validate==='Text'){
          //   if(!input.value.match(/^[a-zA-Z ]*$/))
          //     {
          //       this.props.actions.showPopUpMessage(`Enter Valid ${jsonField.label}`);
          //       return false;
          //     }
        
          // }

        return true
        }
        else{
            if(input.value.length === 0)
               return true

            if(input.value.length<jsonField.minLength){
                this.props.actions.showPopUpMessage(`${jsonField.label} length is too short`);
                return false
              }
              else if( input.value.length >jsonField.maxLength){
                this.props.actions.showPopUpMessage(`${jsonField.label} length is too big`);
                return false
              }
              else if(jsonField.validate==='Phone'){
                if(!input.value.match("^[0-9]*$"))
                  {
                    this.props.actions.showPopUpMessage(`Enter Valid ${jsonField.label}`);
                    return false;
                  }
            
              }
              else if(jsonField.validate==='Email'){
                if(!input.value.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i))
                  {
                    this.props.actions.showPopUpMessage(`Enter Valid ${jsonField.label}`);
                    return false;
                  }
            
              }
              // else if(jsonField.validate==='Text'){
              //   if(!input.value.match(/^[a-zA-Z ]*$/))
              //     {
              //       this.props.actions.showPopUpMessage(`Enter Valid ${jsonField.label}`);
              //       return false;
              //     }
            
              // }
            return true
        }
        } 

    validate = () => { 
        // let formItemDetails = this.props.item || {};
        // let isRequired = formItemDetails.required || formItemDetails.primaryField;
        // let isValidationEnabled = formItemDetails.validate !== "None";
        // if ((!this.messageRef.current.value || !this.messageRef.current.value.trim()) || (this.messageRef.current.value.trim() === this.props.item.label)) {
        //     return isRequired || isValidationEnabled ? false: true;
        // }
        // console.log(this.props.item.maxLength,'cheeking form')
        //validate:{
            //status:true,
    // message:"email/phone/name"}
        if (true) {

            //fetch all filds from json --> props.formfilds
            // while(let i=0;i<formfilds.length){
            //     if(isValidate(formfilds[i]).status)
            //    { i++;}
            //     else
            //    {
            //      break;}
            // }
            //for every filed check for
             const jsonFildsArray=this.props.config.form
             
              const userInput=JSON.parse(localStorage.getItem('userInput'))
              console.log(this.messageRef.current.placeholder,'user check')
            //  console.log(this.messageRef.current.label,'input check')
             
             for(let i=0;i<jsonFildsArray.length;i++){
                  let temp='';
                    if(this.messageRef.current.placeholder.includes('*'))
                      temp=this.messageRef.current.placeholder.replace('*','')
                    else
                        temp=this.messageRef.current.placeholder

                    if(jsonFildsArray[i].label === temp){
                       return this.isValidate(jsonFildsArray[i],this.messageRef.current)
                    }
                
            }
            return true
            
            // localStorage.removeItem('userInput')




           

        //     if(this.props.item.label==='Name' && this.props.item.required===true && this.messageRef.current.value.length===0){
                
               
        //         console.log(this.messageRef.current.value,'value')
        //         this.props.actions.showPopUpMessage('Enter Name');
            
        //        return false;
           
        //  }
        
        //  if ((this.props.item.label==='Phone Number'||this.props.item.label==='Contact Number') && this.props.item.required===true && this.messageRef.current.value.length===0) {
             
                
        //                     console.log(this.messageRef.current.value,'value')
        //              this.props.actions.showPopUpMessage('Enter Phone Number')
        //              return false;
                
        //     }  
          
        // if(this.props.item.label==='Email' && this.props.item.required===true && this.messageRef.current.value.length===0){
                
               
        //         console.log(this.messageRef.current.value,'value')
        //         this.props.actions.showPopUpMessage('Enter Email');
            
        //        return false;
           
        //  }
         
        // //  if (this.props.idxx==='txt5'&& this.messageRef.current.value.length===0) {
                
               
        // //             console.log(this.messageRef.current.value,'value')
        // //             this.props.actions.showPopUpMessage('Enter Phone Number');
                
        // //          return false;
                 
                
        // //      }

        // if(this.props.item.label==='Name'&&this.messageRef.current.value.length>0)
        //   {
        //     if(this.messageRef.current.value.length>this.props.item.maxLength)
        //     {
        //         this.props.actions.showPopUpMessage('Name length is too big');
        //         return false;
        //     }
        //     if(this.messageRef.current.value.length<this.props.item.minLength)
        //     {
        //         this.props.actions.showPopUpMessage('Name length is too short');
        //         return false;
        //     }
        //      console.log(this.messageRef.current.value,'value')
        //      if(!this.messageRef.current.value.match(/^[a-zA-Z ]*$/))
        //     {
        //     this.props.actions.showPopUpMessage('Enter Valid Name');
        //     return false;
        //     }
             
        //   }
        // if((this.props.item.label==='Phone Number'||this.props.item.label==='Contact Number')&&(this.messageRef.current.value.length>0))
        //   {
        //     if(this.messageRef.current.value.length>this.props.item.maxLength)
        //     {
        //         this.props.actions.showPopUpMessage('Phone Number length is too big');
        //         return false;
        //     }
        //     if(this.messageRef.current.value.length<this.props.item.minLength)
        //     {
        //         this.props.actions.showPopUpMessage('Phone Number length is too short');
        //         return false;
        //     }
              
        //       if(!this.messageRef.current.value.match("^[0-9]*$"))
        //       {
        //         this.props.actions.showPopUpMessage('Enter Valid Phone Number');
        //         return false;
        //       }
        //   }
        // //  if((this.props.item.label==='Phone Number'||this.props.item.label==='Contact Number')&&(this.messageRef.current.value.length>0)&&this.props.item.maxLength)
        // //   {
        // //     //   console.log(this.messageRef.current.value.length,'value length')
        // //     //   console.log(this.props.item.maxLength,'maxlenth')
        // //       if(this.messageRef.current.value.length>this.props.item.maxLength)
        // //       {
        // //         this.props.actions.showPopUpMessage('Phone Number is too long');
        // //         return false;
        // //       }
        // //       if(!this.messageRef.current.value.match("^[0-9]*$"))
        // //       {
        // //         this.props.actions.showPopUpMessage('Enter Valid Phone Number');
        // //         return false;
        // //       }
        // //   }


        // //  if((this.props.item.label==='Phone Number'||this.props.item.label==='Contact Number')&&this.messageRef.current.value.length>0&&!this.props.item.maxLength&&!this.props.item.minLength)
        // //      {
        // //         console.log(this.messageRef.current.value,'value')
        // //     if(!this.messageRef.current.value.match(/^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/))
        // //     {
        // //         this.props.actions.showPopUpMessage('Enter Valid Phone Number');
        // //        return false;
        // //     }
               
        // //   }
         
        //  if(this.props.item.label==='Email'&&this.messageRef.current.value.length>0)
        //   {
        //     if(this.messageRef.current.value.length>this.props.item.maxLength)
        //     {
        //         this.props.actions.showPopUpMessage('Email length is too big');
        //         return false;
        //     }
        //     if(this.messageRef.current.value.length<this.props.item.minLength)
        //     {
        //         this.props.actions.showPopUpMessage('Email length is too short');
        //         return false;
        //     }
        //      console.log(this.messageRef.current.value,'value')
        //      if(!this.messageRef.current.value.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i))
        //     {
        //     this.props.actions.showPopUpMessage('Enter Valid Email');
        //     return false;
        //     }
             
        //   }
        //   return true
        // //  if(this.props.idxx==='txt5'&&this.messageRef.current.value.length>0)
        // //   {
        // //     console.log(this.messageRef.current.value,'value')
        // //     if(!this.messageRef.current.value.match(/^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/))
        // //     {
        // //         this.props.actions.showPopUpMessage('Enter Valid Phone Number');
        // //         return false;
        // //     }
             
        // //   }
          
          
       
        
        // // else
        // // {
        // //     if(this.props.idxx==='txt0')
        // //        {
        // //         if(!this.messageRef.current.value.match(/^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/))
        // //         this.props.actions.showPopUpMessage('Enter Valid Phone Number');
                
                
        // //        }
        // //        if(this.props.idxx==='txt1')
        // //        {
                
        // //         this.props.actions.showPopUpMessage('Enter Valid Name');
                
        // //        }
        // //        if(this.props.idxx==='txt5')
        // //        {
        // //         if(!this.messageRef.current.value.match(/^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/))
        // //         this.props.actions.showPopUpMessage('Enter Valid Phone Number');
                
        // //        }

               

        // // }
        // // if (isValidationEnabled) {
        // //     if (formItemDetails.validate.toLowerCase() === "phone") {
        // //         return isValidPhoneNumber(this.messageRef.current.value);
        // //      } else if (formItemDetails.validate.toLowerCase() === "email") {
        // //          return validateEmail(this.messageRef.current.value);
        // //      } else if(formItemDetails.validate.toLowerCase() === "name"){
        // //         return validateName(this.messageRef.current.value);
        // //      }
        // // }
        // // return true;
    }
}

    validationErrorMessage = () => {
        return "Please enter " + this.props.item.label.toLowerCase() + ".";
    }

}

export default TextBox;